import React from 'react';

import TextField from 'material-ui/TextField';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';

import Box from '../ui/Box';

import DataService from '../../services/DataService'; 

var ds = DataService;
var KiotSpinner = null;

export default class NewPromotion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.details ? this.props.details.title : "",
      description: this.props.details ? this.props.details.messge : "",
      spinner: null,
      type: this.props.details ? this.props.details.tag : "",
      dialog: {
        open: false,
        head: 'Dude',
        body: 'This is working',
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      },
      isEdit: this.props.details ? this.props.details.isEdit : false
    };
  }

  handleChanges(e) {
    this.setState({
      [e.target.name]: e.target.value
    })
  }

  closeDialog() {
    this.setState({
      dialog: {
        head: '',
        body: '',
        open: false,
        actions: []
      }
    });
  }


  createPromo(e) {
    e.preventDefault()
    if (this.validated()) {

      this.setState({
        spinner: <KiotSpinner />
      });

      if (this.props.details && this.props.details._id) {
        ds.postEditPromo({
          _id: this.props.details._id,
          title: this.state.title,
          messge: this.state.description,
          tag: this.state.type
        }, data => {
          this.props.unMountMe(true);
          this.setState({
            title: "",
            description: "",
            spinner: null
          });
        }, err => {});

      } else {
        ds.postCreatePromo({
          title: this.state.title,
          messge: this.state.description,
          tag: this.state.type

        }, data => {
          let dialog = {
            open: true,
            head: 'Success',
            body: "Promotion added",
            actions: [
              <FlatButton
                label="Okay"
                primary
                onClick={this.closeDialog.bind(this)}
              />
            ]
          }
          let evt = new CustomEvent('updatePromoTable', { detail: true });
          window.dispatchEvent(evt);
          this.setState({
            title: '',
            description: '',
            type: '',
            dialog: dialog
          });
        }, err => {
          this.setState({
            spinner: null
          })
        })
      }
    }
  }

  validated() {
    let dialog;
    let flag = true;
    if (!this.state.title || !this.state.description || !this.state.type) {

      dialog = {
        open: true,
        head: 'Invalid',
        body: "All Fields are mandatory",
        actions: [
          <FlatButton
            label="Okay"
            primary
            onClick={this.closeDialog.bind(this)}
          />
        ]
      }
      flag = false;
    }

    if (!flag) {
      this.setState({
        dialog: dialog
      })
    }
    return flag;
  }

  render() {
    return (
      <Box header={this.state.isEdit == true ? 'Edit Promotion' : 'New Promotion'}>
        <Dialog
          title={this.state.dialog.head}
          autoScrollBodyContent={true}
          actions={this.state.dialog.actions}
          modal={false}
          open={this.state.dialog.open}
          onRequestClose={this.closeDialog.bind(this)}
        >
          {this.state.dialog.body || 'NA'}
        </Dialog>

        <div className="col-sm-12">
          <form className="smart-form " onSubmit={this.createPromo.bind(this)}>
            <fieldset>
              <section>
                <TextField
                  floatingLabelText="Title"
                  name="title"
                  className="w-100"
                  value={this.state.title}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Description"
                  name="description"
                  multiLine={true}
                  rows={2}
                  rowsMax={4}
                  className="w-100"
                  value={this.state.description}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>

              <section>
                <TextField
                  floatingLabelText="Category"
                  name="type"
                  className="w-100"
                  value={this.state.type}
                  onChange={this.handleChanges.bind(this)}
                />
              </section>
            </fieldset>

            <div className="mt-4vw align-right">
              <RaisedButton
                label="Save"
                primary
                type="submit"
              />
              <span className="space"></span>
              {
                this.props.details ?
                  <FlatButton
                    label="Cancel"
                    primary
                    onClick={this.props.unMountMe.bind(this, false)}
                    type="button"
                  /> 
                : null
              }
            </div>
          </form>
        </div>
      </Box>
    )
  }
}


// WEBPACK FOOTER //
// ./components/promotions/NewPromotion.js